/**
 * Tailwind CSS color tokens as JS objects.
 *
 * https://tailwindcss.com/docs/theme#referencing-in-javascript
 */
export const Color = {
  RED_50: 'oklch(0.971 0.013 17.38)',
  RED_100: 'oklch(0.936 0.032 17.717)',
  RED_200: 'oklch(0.885 0.062 18.334)',
  RED_300: 'oklch(0.808 0.114 19.571)',
  RED_400: 'oklch(0.704 0.191 22.216)',
  RED_500: 'oklch(0.637 0.237 25.331)',
  RED_600: 'oklch(0.577 0.245 27.325)',
  RED_700: 'oklch(0.505 0.213 27.518)',
  RED_800: 'oklch(0.444 0.177 26.899)',
  RED_900: 'oklch(0.396 0.141 25.723)',
  RED_950: 'oklch(0.258 0.092 26.042)',

  ORANGE_50: 'oklch(0.98 0.016 73.684)',
  ORANGE_100: 'oklch(0.954 0.038 75.164)',
  ORANGE_200: 'oklch(0.901 0.076 70.697)',
  ORANGE_300: 'oklch(0.837 0.128 66.29)',
  ORANGE_400: 'oklch(0.75 0.183 55.934)',
  ORANGE_500: 'oklch(0.705 0.213 47.604)',
  ORANGE_600: 'oklch(0.646 0.222 41.116)',
  ORANGE_700: 'oklch(0.553 0.195 38.402)',
  ORANGE_800: 'oklch(0.47 0.157 37.304)',
  ORANGE_900: 'oklch(0.408 0.123 38.172)',
  ORANGE_950: 'oklch(0.266 0.079 36.259)',

  AMBER_50: 'oklch(0.987 0.022 95.277)',
  AMBER_100: 'oklch(0.962 0.059 95.617)',
  AMBER_200: 'oklch(0.924 0.12 95.746)',
  AMBER_300: 'oklch(0.879 0.169 91.605)',
  AMBER_400: 'oklch(0.828 0.189 84.429)',
  AMBER_500: 'oklch(0.769 0.188 70.08)',
  AMBER_600: 'oklch(0.666 0.179 58.318)',
  AMBER_700: 'oklch(0.555 0.163 48.998)',
  AMBER_800: 'oklch(0.473 0.137 46.201)',
  AMBER_900: 'oklch(0.414 0.112 45.904)',
  AMBER_950: 'oklch(0.279 0.077 45.635)',

  YELLOW_50: 'oklch(0.987 0.026 102.212)',
  YELLOW_100: 'oklch(0.973 0.071 103.193)',
  YELLOW_200: 'oklch(0.945 0.129 101.54)',
  YELLOW_300: 'oklch(0.905 0.182 98.111)',
  YELLOW_400: 'oklch(0.852 0.199 91.936)',
  YELLOW_500: 'oklch(0.795 0.184 86.047)',
  YELLOW_600: 'oklch(0.681 0.162 75.834)',
  YELLOW_700: 'oklch(0.554 0.135 66.442)',
  YELLOW_800: 'oklch(0.476 0.114 61.907)',
  YELLOW_900: 'oklch(0.421 0.095 57.708)',
  YELLOW_950: 'oklch(0.286 0.066 53.813)',

  LIME_50: 'oklch(0.986 0.031 120.757)',
  LIME_100: 'oklch(0.967 0.067 122.328)',
  LIME_200: 'oklch(0.938 0.127 124.321)',
  LIME_300: 'oklch(0.897 0.196 126.665)',
  LIME_400: 'oklch(0.841 0.238 128.85)',
  LIME_500: 'oklch(0.768 0.233 130.85)',
  LIME_600: 'oklch(0.648 0.2 131.684)',
  LIME_700: 'oklch(0.532 0.157 131.589)',
  LIME_800: 'oklch(0.453 0.124 130.933)',
  LIME_900: 'oklch(0.405 0.101 131.063)',
  LIME_950: 'oklch(0.274 0.072 132.109)',

  GREEN_50: 'oklch(0.982 0.018 155.826)',
  GREEN_100: 'oklch(0.962 0.044 156.743)',
  GREEN_200: 'oklch(0.925 0.084 155.995)',
  GREEN_300: 'oklch(0.871 0.15 154.449)',
  GREEN_400: 'oklch(0.792 0.209 151.711)',
  GREEN_500: 'oklch(0.723 0.219 149.579)',
  GREEN_600: 'oklch(0.627 0.194 149.214)',
  GREEN_700: 'oklch(0.527 0.154 150.069)',
  GREEN_800: 'oklch(0.448 0.119 151.328)',
  GREEN_900: 'oklch(0.393 0.095 152.535)',
  GREEN_950: 'oklch(0.266 0.065 152.934)',

  EMERALD_50: 'oklch(0.979 0.021 166.113)',
  EMERALD_100: 'oklch(0.95 0.052 163.051)',
  EMERALD_200: 'oklch(0.905 0.093 164.15)',
  EMERALD_300: 'oklch(0.845 0.143 164.978)',
  EMERALD_400: 'oklch(0.765 0.177 163.223)',
  EMERALD_500: 'oklch(0.696 0.17 162.48)',
  EMERALD_600: 'oklch(0.596 0.145 163.225)',
  EMERALD_700: 'oklch(0.508 0.118 165.612)',
  EMERALD_800: 'oklch(0.432 0.095 166.913)',
  EMERALD_900: 'oklch(0.378 0.077 168.94)',
  EMERALD_950: 'oklch(0.262 0.051 172.552)',

  TEAL_50: 'oklch(0.984 0.014 180.72)',
  TEAL_100: 'oklch(0.953 0.051 180.801)',
  TEAL_200: 'oklch(0.91 0.096 180.426)',
  TEAL_300: 'oklch(0.855 0.138 181.071)',
  TEAL_400: 'oklch(0.777 0.152 181.912)',
  TEAL_500: 'oklch(0.704 0.14 182.503)',
  TEAL_600: 'oklch(0.6 0.118 184.704)',
  TEAL_700: 'oklch(0.511 0.096 186.391)',
  TEAL_800: 'oklch(0.437 0.078 188.216)',
  TEAL_900: 'oklch(0.386 0.063 188.416)',
  TEAL_950: 'oklch(0.277 0.046 192.524)',

  CYAN_50: 'oklch(0.984 0.019 200.873)',
  CYAN_100: 'oklch(0.956 0.045 203.388)',
  CYAN_200: 'oklch(0.917 0.08 205.041)',
  CYAN_300: 'oklch(0.865 0.127 207.078)',
  CYAN_400: 'oklch(0.789 0.154 211.53)',
  CYAN_500: 'oklch(0.715 0.143 215.221)',
  CYAN_600: 'oklch(0.609 0.126 221.723)',
  CYAN_700: 'oklch(0.52 0.105 223.128)',
  CYAN_800: 'oklch(0.45 0.085 224.283)',
  CYAN_900: 'oklch(0.398 0.07 227.392)',
  CYAN_950: 'oklch(0.302 0.056 229.695)',

  SKY_50: 'oklch(0.977 0.013 236.62)',
  SKY_100: 'oklch(0.951 0.026 236.824)',
  SKY_200: 'oklch(0.901 0.058 230.902)',
  SKY_300: 'oklch(0.828 0.111 230.318)',
  SKY_400: 'oklch(0.746 0.16 232.661)',
  SKY_500: 'oklch(0.685 0.169 237.323)',
  SKY_600: 'oklch(0.588 0.158 241.966)',
  SKY_700: 'oklch(0.5 0.134 242.749)',
  SKY_800: 'oklch(0.443 0.11 240.79)',
  SKY_900: 'oklch(0.391 0.09 240.876)',
  SKY_950: 'oklch(0.293 0.066 243.157)',

  BLUE_50: 'oklch(0.97 0.014 254.604)',
  BLUE_100: 'oklch(0.932 0.032 255.585)',
  BLUE_200: 'oklch(0.882 0.059 254.128)',
  BLUE_300: 'oklch(0.809 0.105 251.813)',
  BLUE_400: 'oklch(0.707 0.165 254.624)',
  BLUE_500: 'oklch(0.623 0.214 259.815)',
  BLUE_600: 'oklch(0.546 0.245 262.881)',
  BLUE_700: 'oklch(0.488 0.243 264.376)',
  BLUE_800: 'oklch(0.424 0.199 265.638)',
  BLUE_900: 'oklch(0.379 0.146 265.522)',
  BLUE_950: 'oklch(0.282 0.091 267.935)',

  INDIGO_50: 'oklch(0.962 0.018 272.314)',
  INDIGO_100: 'oklch(0.93 0.034 272.788)',
  INDIGO_200: 'oklch(0.87 0.065 274.039)',
  INDIGO_300: 'oklch(0.785 0.115 274.713)',
  INDIGO_400: 'oklch(0.673 0.182 276.935)',
  INDIGO_500: 'oklch(0.585 0.233 277.117)',
  INDIGO_600: 'oklch(0.511 0.262 276.966)',
  INDIGO_700: 'oklch(0.457 0.24 277.023)',
  INDIGO_800: 'oklch(0.398 0.195 277.366)',
  INDIGO_900: 'oklch(0.359 0.144 278.697)',
  INDIGO_950: 'oklch(0.257 0.09 281.288)',

  VIOLET_50: 'oklch(0.969 0.016 293.756)',
  VIOLET_100: 'oklch(0.943 0.029 294.588)',
  VIOLET_200: 'oklch(0.894 0.057 293.283)',
  VIOLET_300: 'oklch(0.811 0.111 293.571)',
  VIOLET_400: 'oklch(0.702 0.183 293.541)',
  VIOLET_500: 'oklch(0.606 0.25 292.717)',
  VIOLET_600: 'oklch(0.541 0.281 293.009)',
  VIOLET_700: 'oklch(0.491 0.27 292.581)',
  VIOLET_800: 'oklch(0.432 0.232 292.759)',
  VIOLET_900: 'oklch(0.38 0.189 293.745)',
  VIOLET_950: 'oklch(0.283 0.141 291.089)',

  PURPLE_50: 'oklch(0.977 0.014 308.299)',
  PURPLE_100: 'oklch(0.946 0.033 307.174)',
  PURPLE_200: 'oklch(0.902 0.063 306.703)',
  PURPLE_300: 'oklch(0.827 0.119 306.383)',
  PURPLE_400: 'oklch(0.714 0.203 305.504)',
  PURPLE_500: 'oklch(0.627 0.265 303.9)',
  PURPLE_600: 'oklch(0.558 0.288 302.321)',
  PURPLE_700: 'oklch(0.496 0.265 301.924)',
  PURPLE_800: 'oklch(0.438 0.218 303.724)',
  PURPLE_900: 'oklch(0.381 0.176 304.987)',
  PURPLE_950: 'oklch(0.291 0.149 302.717)',

  FUCHSIA_50: 'oklch(0.977 0.017 320.058)',
  FUCHSIA_100: 'oklch(0.952 0.037 318.852)',
  FUCHSIA_200: 'oklch(0.903 0.076 319.62)',
  FUCHSIA_300: 'oklch(0.833 0.145 321.434)',
  FUCHSIA_400: 'oklch(0.74 0.238 322.16)',
  FUCHSIA_500: 'oklch(0.667 0.295 322.15)',
  FUCHSIA_600: 'oklch(0.591 0.293 322.896)',
  FUCHSIA_700: 'oklch(0.518 0.253 323.949)',
  FUCHSIA_800: 'oklch(0.452 0.211 324.591)',
  FUCHSIA_900: 'oklch(0.401 0.17 325.612)',
  FUCHSIA_950: 'oklch(0.293 0.136 325.661)',

  PINK_50: 'oklch(0.971 0.014 343.198)',
  PINK_100: 'oklch(0.948 0.028 342.258)',
  PINK_200: 'oklch(0.899 0.061 343.231)',
  PINK_300: 'oklch(0.823 0.12 346.018)',
  PINK_400: 'oklch(0.718 0.202 349.761)',
  PINK_500: 'oklch(0.656 0.241 354.308)',
  PINK_600: 'oklch(0.592 0.249 0.584)',
  PINK_700: 'oklch(0.525 0.223 3.958)',
  PINK_800: 'oklch(0.459 0.187 3.815)',
  PINK_900: 'oklch(0.408 0.153 2.432)',
  PINK_950: 'oklch(0.284 0.109 3.907)',

  ROSE_50: 'oklch(0.969 0.015 12.422)',
  ROSE_100: 'oklch(0.941 0.03 12.58)',
  ROSE_200: 'oklch(0.892 0.058 10.001)',
  ROSE_300: 'oklch(0.81 0.117 11.638)',
  ROSE_400: 'oklch(0.712 0.194 13.428)',
  ROSE_500: 'oklch(0.645 0.246 16.439)',
  ROSE_600: 'oklch(0.586 0.253 17.585)',
  ROSE_700: 'oklch(0.514 0.222 16.935)',
  ROSE_800: 'oklch(0.455 0.188 13.697)',
  ROSE_900: 'oklch(0.41 0.159 10.272)',
  ROSE_950: 'oklch(0.271 0.105 12.094)',

  SLATE_50: 'oklch(0.984 0.003 247.858)',
  SLATE_100: 'oklch(0.968 0.007 247.896)',
  SLATE_200: 'oklch(0.929 0.013 255.508)',
  SLATE_300: 'oklch(0.869 0.022 252.894)',
  SLATE_400: 'oklch(0.704 0.04 256.788)',
  SLATE_500: 'oklch(0.554 0.046 257.417)',
  SLATE_600: 'oklch(0.446 0.043 257.281)',
  SLATE_700: 'oklch(0.372 0.044 257.287)',
  SLATE_800: 'oklch(0.279 0.041 260.031)',
  SLATE_900: 'oklch(0.208 0.042 265.755)',
  SLATE_950: 'oklch(0.129 0.042 264.695)',

  GRAY_50: 'oklch(0.985 0.002 247.839)',
  GRAY_100: 'oklch(0.967 0.003 264.542)',
  GRAY_200: 'oklch(0.928 0.006 264.531)',
  GRAY_300: 'oklch(0.872 0.01 258.338)',
  GRAY_400: 'oklch(0.707 0.022 261.325)',
  GRAY_500: 'oklch(0.551 0.027 264.364)',
  GRAY_600: 'oklch(0.446 0.03 256.802)',
  GRAY_700: 'oklch(0.373 0.034 259.733)',
  GRAY_800: 'oklch(0.278 0.033 256.848)',
  GRAY_900: 'oklch(0.21 0.034 264.665)',
  GRAY_950: 'oklch(0.13 0.028 261.692)',

  ZINC_50: 'oklch(0.985 0 0)',
  ZINC_100: 'oklch(0.967 0.001 286.375)',
  ZINC_200: 'oklch(0.92 0.004 286.32)',
  ZINC_300: 'oklch(0.871 0.006 286.286)',
  ZINC_400: 'oklch(0.705 0.015 286.067)',
  ZINC_500: 'oklch(0.552 0.016 285.938)',
  ZINC_600: 'oklch(0.442 0.017 285.786)',
  ZINC_700: 'oklch(0.37 0.013 285.805)',
  ZINC_800: 'oklch(0.274 0.006 286.033)',
  ZINC_900: 'oklch(0.21 0.006 285.885)',
  ZINC_950: 'oklch(0.141 0.005 285.823)',

  NEUTRAL_50: 'oklch(0.985 0 0)',
  NEUTRAL_100: 'oklch(0.97 0 0)',
  NEUTRAL_200: 'oklch(0.922 0 0)',
  NEUTRAL_300: 'oklch(0.87 0 0)',
  NEUTRAL_400: 'oklch(0.708 0 0)',
  NEUTRAL_500: 'oklch(0.556 0 0)',
  NEUTRAL_600: 'oklch(0.439 0 0)',
  NEUTRAL_700: 'oklch(0.371 0 0)',
  NEUTRAL_800: 'oklch(0.269 0 0)',
  NEUTRAL_900: 'oklch(0.205 0 0)',
  NEUTRAL_950: 'oklch(0.145 0 0)',

  STONE_50: 'oklch(0.985 0.001 106.423)',
  STONE_100: 'oklch(0.97 0.001 106.424)',
  STONE_200: 'oklch(0.923 0.003 48.717)',
  STONE_300: 'oklch(0.869 0.005 56.366)',
  STONE_400: 'oklch(0.709 0.01 56.259)',
  STONE_500: 'oklch(0.553 0.013 58.071)',
  STONE_600: 'oklch(0.444 0.011 73.639)',
  STONE_700: 'oklch(0.374 0.01 67.558)',
  STONE_800: 'oklch(0.268 0.007 34.298)',
  STONE_900: 'oklch(0.216 0.006 56.043)',
  STONE_950: 'oklch(0.147 0.004 49.25)',

  BLACK: '#000000',
  WHITE: '#ffffff',
} as const;
export type Color = (typeof Color)[keyof typeof Color];

export const TextColor = {
  red: 'text-red-500',
  orange: 'text-orange-500',
  amber: 'text-amber-500',
  yellow: 'text-yellow-500',
  lime: 'text-lime-500',
  green: 'text-green-500',
  emerald: 'text-emerald-500',
  teal: 'text-teal-500',
  cyan: 'text-cyan-500',
  sky: 'text-sky-500',
  blue: 'text-blue-500',
  indigo: 'text-indigo-500',
  violet: 'text-violet-500',
  purple: 'text-purple-500',
  fuchsia: 'text-fuchsia-500',
  pink: 'text-pink-500',
  rose: 'text-rose-500',
  zinc: 'text-zinc-500 dark:text-zinc-400',
  'light/dark': 'text-zinc-700 dark:text-zinc-300',
} as const;
export type TextColor = keyof typeof TextColor;
